import Bookkeeping from '../../../views/Finance/Bookkeeping/Bookkeeping.view';

export default Bookkeeping;
